import { match } from 'ts-pattern'
import type {
  BindingConfig,
  Binding,
  BindingDefinition,
} from '@wix/wix-data-client-types'

const isBindingValueForThisDefinition = (
  config: BindingConfig,
  definition: BindingDefinition,
) =>
  match(config)
    .with({ type: 'Field' }, ({ prop }) => definition.prop === prop)
    .with(
      { type: 'Action' },
      ({ event }) => 'event' in definition && definition.event === event,
    )
    .with({ type: 'Behavior' }, ({ behavior }) =>
      (
        ('supportedBehaviors' in definition && definition.supportedBehaviors) ||
        []
      ).includes(behavior),
    )
    .with({ type: 'Filter' }, ({ prop }) => definition.prop === prop)
    .with({ type: 'Expression' }, ({ prop }) => definition.prop === prop)
    .with({ type: 'TotalCount' }, ({ prop }) => definition.prop === prop)
    .exhaustive()

export const pairBindingsWithProps = (
  bindings: BindingConfig[],
  defs: BindingDefinition[],
) =>
  defs.reduce(
    (bindingsWithDefs, definition) =>
      bindingsWithDefs.concat({
        definition,
        config: bindings.find(binding =>
          isBindingValueForThisDefinition(binding, definition),
        )!,
      }),
    [] as Binding[],
  )
